import { makeStyles } from 'tss-react/mui';
import { DESKTOP_ROOT_PAGE_PADDING_TOP } from '../../utils/constants';

const useColumnsVisibilityStyles = makeStyles()((theme) => ({
  filterPaper: {
    maxWidth: '400px',
    minWidth: '330px',
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      boxShadow: 'unset',
    },
  },
  headerWrapper: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
      zIndex: 999,
      padding: '16px',
    },
  },
  content: {
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: '110px',
      marginBottom: '62px',
      maxHeight: 'unset',
    },
    maxHeight: `calc(60vh - ${DESKTOP_ROOT_PAGE_PADDING_TOP}px - 30px)`,
  },
  footer: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
      zIndex: 999,
    },
  },
}));

export default useColumnsVisibilityStyles;
